import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";

import Header from "../components/Template/Header";
import SideBar from "../components/Template/SideBar";

import AdminRoutes from "./admin.routes";
import EntityRoutes from "./entity.routes";

type Props = {
  role: string;
};

const AppRoutes: React.FC<Props> = ({ role }) => {
  return (
    <BrowserRouter>
      <div className="flex h-screen w-screen">
        <SideBar role={role} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <Switch>
            {role === "admin" && <AdminRoutes />}
            {role === "entity" && <EntityRoutes />}
          </Switch>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default AppRoutes;
